package io.horion.cv.di

import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.viewModel.DashboardViewModel
import io.horion.cv.viewModel.JobViewModel
import io.horion.cv.viewModel.LetterViewModel
import io.horion.cv.viewModel.PayViewModel
import io.horion.cv.viewModel.UpdateCvViewModel
import org.koin.dsl.module

val viewModelModules = module {
    single { CvViewModel(get()) }
    single { DashboardViewModel(get()) }
    single { UpdateCvViewModel(get()) }
    single { LetterViewModel(get()) }
    single { JobViewModel(get()) }
    single { PayViewModel(get()) }

}